/**
 * Curated set of product × city landing pages we actively want indexed.
 *
 * Google was crawling 120 near-identical /supplier/... combinations and
 * skipping most of them ("Crawled - currently not indexed"). We keep a small,
 * genuinely differentiated set in the sitemap and mark the rest noindex so
 * crawl budget goes to pages that can realistically rank.
 */
export const PRIORITY_PRODUCT_SLUGS = [
  "ms-round-pipes",
  "ms-square-pipes",
  "gi-pipes-tubes",
  "erw-steel-tubes",
  "zoloto-valves",
] as const;

export const PRIORITY_CITY_SLUGS = [
  "coimbatore",
  "chennai",
  "bangalore",
  "kochi",
] as const;

export const isPriorityProduct = (slug?: string) =>
  !!slug && (PRIORITY_PRODUCT_SLUGS as readonly string[]).includes(slug);

export const isPriorityCity = (slug?: string) =>
  !!slug && (PRIORITY_CITY_SLUGS as readonly string[]).includes(slug);

/** True when this product+city page should be indexed and linked. */
export const isPriorityCombo = (productSlug?: string, citySlug?: string) =>
  isPriorityProduct(productSlug) && isPriorityCity(citySlug);
